//@flow
import Enum from './Enum';
import camelCase from 'lodash/camelCase';

export class UIEnum extends Enum {
    getSizeClass({
        theme,
        size,
        suffix
    }: {
        theme: Object,
        size: ?SizeEnumType,
        suffix?: string
    }) {
        return this.getThemeClass({
            classSuffix: 'Size',
            value: size,
            suffix,
            theme
        });
    }

    getTypeClass({
        theme,
        type,
        suffix
    }: {
        theme: Object,
        type: string,
        suffix?: string
    }) {
        return this.getThemeClass({
            classSuffix: 'Type',
            value: type,
            suffix,
            theme
        });
    }
    getThemeClass({
        theme,
        value,
        classSuffix,
        suffix
    }: {
        theme: Object,
        classSuffix: string,
        value: string,
        suffix?: string
    }) {
        const camelCaseValue = camelCase(value);
        const classString = suffix
            ? `${camelCaseValue}${classSuffix}${suffix}`
            : `${camelCaseValue}${classSuffix}`;
        return theme[classString];
    }
}

export const SizeEnum = new UIEnum({
    Default: 'default',
    Small: 'small',
    Medium: 'medium',
    Large: 'large',
    Largest: 'largest',
    Auto: 'auto'
});

export type SizeEnumType = 'default' | 'small' | 'large' | 'largest';
